/* src/app/features/contratacao/cancelamento/cancelamento-listagem.component.scss */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
.negativo {
  color: red;
}
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=cancelamento-listagem.component.css.map */
